import HexagonIcon from '@mui/icons-material/Hexagon';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useNavigate, useParams } from 'react-router-dom';
import { BadgeOne, BadgeThree, BadgeTwo, Mascot, RewardCoin } from '../../../assets/commonicons/CommonIcons';
import { GirlImage } from '../../../assets/images';
import AudioPlay from '../../../components/AudioPlay';
import Confetti from '../../../components/Confettie';
import useAuth from '../../../hooks/useAuth';
import { axios } from '../../../lib/axios';
import ConditionalBadgesText from '../ConditionalBadgesText';
import Feedback from './Feedback';
import './lastpage.css';

Modal.setAppElement('#root');
const LastPage = ({ score, tryAgain, answers, goBack, questionList }) => {
    const [showFeedback, setShowFeedback] = useState(false);
    const { auth } = useAuth();
    let { chaptername } = useParams();

    const toggleFeedback = () => {
        setShowFeedback(!showFeedback);
    };

    const { ConditionalConfetti, ConditionalBadges, ConditionalFinalText, ConditionalFinalTextNormalUser } = ConditionalBadgesText({
        score,
    });

    return showFeedback == false ? (
        <div className='lastcontainer'>
            <ConditionalConfetti />
            <AudioPlay />
            <div className='left'>
                {/* <div className="closecross">X</div> */}
                <div className='points'>
                    <div className='pointDiv'>
                        <img src={RewardCoin} alt='' />
                    </div>
                    <div className='pointDiv'>{score.correct * 20} points</div>
                    {/* <div className="pointDivider" />
          <div className="pointDiv">i</div> */}
                </div>
            </div>
            <div className='center'>
                <div className='centerTop'>
                    <ConditionalBadges />
                </div>
                <div className='centerBottom'>
                    <div className='centerBottomTop'>
                        <div>
                            <ConditionalFinalText />
                            <ConditionalFinalTextNormalUser />
                        </div>
                        {/* <div> green bar thingy</div> */}
                    </div>
                    <div className='centerBottomBottom'>
                        <div className='centerBottomDiv'>
                            <div className='number total'>{score.total}</div>
                            <div>Total</div>
                        </div>
                        <div className='centerBottomDiv'>
                            <div className='number correct'>{score.correct}</div>
                            <div>Correct</div>
                        </div>
                        <div className='centerBottomDiv'>
                            <div className='number wrong'>{score.incorrect}</div>
                            <div>Wrong</div>
                        </div>
                        <div className='centerBottomDiv'>
                            <div className='number skipped'>{score.skipped}</div>
                            <div>Skipped</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=' right'>
                <div onClick={tryAgain} className='lastButton red'>
                    Try Again
                </div>
                <div onClick={goBack} className='lastButton green'>
                    Continue
                </div>
                <div onClick={toggleFeedback} className='lastButton blue'>
                    View Feedback
                </div>
            </div>
        </div>
    ) : (
        <Feedback goBack={toggleFeedback} answers={answers} score={score} questionList={questionList} />
    );
};

export default LastPage;
